import { render, staticRenderFns } from "./ArticleDetailPanel.vue?vue&type=template&id=964d3538&scoped=true"
import script from "./ArticleDetailPanel.vue?vue&type=script&lang=js"
export * from "./ArticleDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetailPanel.vue?vue&type=style&index=0&id=964d3538&prod&lang=css"
import style1 from "./ArticleDetailPanel.vue?vue&type=style&index=1&id=964d3538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964d3538",
  null
  
)

export default component.exports